import ValidacaoServicosPrestadosMixin from "../../../shared/mixins/validation/ValidacaoServicosPrestadosMixin";
import QuestionarioCentroDiagnosticoMixin from "../../QuestionarioCentroDiagnostico.mixin";
import ServicosService from "./ServicosService";

export default {
  mixins: [
    ValidacaoServicosPrestadosMixin,
    ServicosService,
    QuestionarioCentroDiagnosticoMixin
  ],
  data() {
    return {
      objetoServicos: {
        "Hospital Dia": {
          id: null,
          ativo: false,
          preenchido: false,
          payload: {}
        },
        Laboratório: { id: null, ativo: false, preenchido: false, payload: {} },
        "Centro de Diagnóstico": {
          id: null,
          ativo: false,
          preenchido: false,
          payload: {}
        },
        "Atendimento Médico Eletivo": {
          id: null,
          ativo: false,
          preenchido: false,
          payload: {}
        },
        Outros: { id: null, ativo: false, preenchido: false, payload: {} },
        "Agência Transfusional": {
          id: null,
          ativo: false,
          preenchido: false,
          payload: {}
        },
        "Pronto Atendimento": {
          id: null,
          ativo: false,
          preenchido: true,
          payload: {}
        },
        "Posto de Coleta": {
          id: null,
          ativo: false,
          preenchido: false,
          payload: {}
        },
        "Pronto Socorro": {
          id: null,
          ativo: false,
          preenchido: false,
          payload: {}
        },
        "Serviço de Remoção": {
          id: null,
          ativo: false,
          preenchido: false,
          payload: {}
        },
        "Serviço de Atenção Domiciliar": {
          id: null,
          ativo: false,
          preenchido: false,
          payload: {}
        }
      },

      payloadServicos: [],
      payloadEspecialidades: [],
      payloadAbrancencias: [],

      dadosServidorServ: {
        servicos: [],
        abrangencias: [],
        especialidades: []
      }
    };
  },
  beforeMount() {
    this.inicializarServicos().finally(() => {
      this.preencherDadosServidor();
    });
  },
  methods: {
    async inicializarServicos() {
      const { data } = await this.getServicos();

      if (!data) return;

      data.forEach(obj => {
        // A função trim está corrigindo um typo do backend no servico 'Serviço de Atenção Domiciliar'
        // Tem um espaço a mais no final
        this.objetoServicos[obj.tipoServico.trim()].id = obj.id;
        this.objetoServicos[obj.tipoServico.trim()].ativo = true;
      });
    },
    verificaNulo(texto) {
      return !!texto;
    },

    async preencherDadosServidor() {
      const payloadServidor = this.$store.getters.getPayloadServidor();

      if (payloadServidor) {
        this.dadosServidorServ = {
          servicos: payloadServidor.servicos,
          abrangencias: payloadServidor.abrangencias,
          especialidades: payloadServidor.especialidades
        };
      }
    },

    formatarEspecialidades(data, especialidades) {
      let cadaEspecialidade;

      this.payloadEspecialidades = this.payloadEspecialidades.filter(
        e => e.tipoServico.id !== data[1].id
      );

      especialidades.forEach(el => {
        cadaEspecialidade = {
          idQuestionarioServicoEspecialidade: "",
          tipoServicoEspecialidade: {
            id: el.id,
            tipoServicoEspecialidade: el.tipoServicoEspecialidade
          },
          tipoServico: {
            id: data[1].id,
            tipoServico: data[0]
          }
        };

        const existe = this.payloadEspecialidades.find(
          esp => esp.tipoServicoEspecialidade.id === el.id
        );

        if (existe) return;

        this.payloadEspecialidades.push(cadaEspecialidade);
      });
    },
    formatarAbrangencias(data, abrangencia) {
      this.payloadAbrancencias = [];

      let tipoServicoAbrangencia;

      if (!abrangencia) {
        return;
      } else if (Object.keys(abrangencia).length < 1) {
        return;
      } else {
        tipoServicoAbrangencia = {
          id: abrangencia.id,
          tipoServicoAbrangencia: abrangencia.tipoServicoAbrangencia
        };
      }

      let cadaAbrangencia = {
        idQuestionarioServicoAbrangencia: "",
        tipoServico: {
          id: data[1].id,
          tipoServico: data[0]
        },
        tipoServicoAbrangencia
      };

      this.payloadAbrancencias.push(cadaAbrangencia);
    },
    preparaDadosServicos() {
      this.payloadServicos = [];
      let cadaServico = {};

      Object.entries(this.objetoServicos).forEach(servico => {
        if (!servico[1].ativo) return;
        if (!servico[1].preenchido) return;

        const { payload } = servico[1];
        let outro = "";
        let numeroLeitosObservacao = null;
        let especialidadesOferecidas = "";
        let tipoServicoPublico = null;

        if (payload.tipoServicoEspecialidade) {
          this.formatarEspecialidades(
            servico,
            payload.tipoServicoEspecialidade
          );
        }

        if (
          servico[0] === "Serviço de Remoção" && // pq??
          !payload.tipoServicoAbrangencia
        ) {
          this.formatarAbrangencias(servico, {});
        }
        if (
          Array.isArray(payload.tipoServicoAbrangencia) &&
          payload.tipoServicoAbrangencia
        ) {
          this.formatarAbrangencias(servico, payload.tipoServicoAbrangencia[0]);
        }
        if (
          isObject(payload.tipoServicoAbrangencia) &&
          payload.tipoServicoAbrangencia
        ) {
          this.formatarAbrangencias(servico, payload.tipoServicoAbrangencia);
        }
        if (
          Array.isArray(payload.tipoServicoPublico) &&
          payload.tipoServicoPublico.length > 0
        ) {
          tipoServicoPublico = payload.tipoServicoPublico[0];
        }
        if (!payload.tipoServicoPublico) {
          tipoServicoPublico = null;
        }
        if (
          isObject(payload.tipoServicoPublico) &&
          payload.tipoServicoPublico
        ) {
          tipoServicoPublico = {
            id: payload.tipoServicoPublico.id,
            tipoServicoPublico: payload.tipoServicoPublico.tipoServicoPublico
          };
        }

        if (payload.outro) outro = payload.outro;
        if (payload.numeroLeitosObservacao) {
          numeroLeitosObservacao = +payload.numeroLeitosObservacao || 0;
        }
        if (payload.especialidadesOferecidas) {
          especialidadesOferecidas = payload.especialidadesOferecidas;
        }

        cadaServico = {
          idQuestionarioServico: "",
          tipoServico: {
            id: servico[1].id,
            tipoServico: servico[0]
          },
          tipoServicoPublico,
          especialidadesOferecidas,
          numeroLeitosObservacao,
          outro
        };

        this.payloadServicos.push(cadaServico);
      });

      this.$emit("payload-atualizado", {
        servicos: [...this.payloadServicos],
        especialidades: [...this.payloadEspecialidades],
        abrangencias: this.payloadAbrancencias
      });
    }
  },
  watch: {}
};

const isObject = obj => {
  return Object.prototype.toString.call(obj) === "[object Object]";
};
